import type { CompetitorOutcome } from 'app/components/MatchMarket/MatchMarketOutcomes/types';
import type { CompetitorOddsWithStatus } from 'app/pages/EventsPage/types';

import {
  COMPETITORS_ORDER,
  EVENT_LIST_COMPETITORS,
  MARKET_CATEGORY_COMPETITORS,
  MARKET_TEMPLATES_COMPETITORS,
  MATCH_PAGE_COMPETITORS,
  MONITORING_COMPETITORS
} from './competitors.config';

const displayCompetitorOutcome = (
  competitorOutcome: CompetitorOutcome,
  matchStatus: MatchStatus,
  marketStatus: MarketStatus,
  eventId: number,
  eventType: BlueprintEventType,
  outcome: Outcome,
  template: string
): boolean =>
  ['active', 'suspended'].includes(marketStatus) &&
  MATCH_PAGE_COMPETITORS[competitorOutcome.competitor_slug].includes(matchStatus) &&
  competitorOutcome.event_type === eventType &&
  competitorOutcome.event_id === eventId &&
  competitorOutcome.outcome.participant_id === outcome.participant_id &&
  competitorOutcome.outcome.template === outcome.template &&
  competitorOutcome.market_template === template &&
  competitorOutcome.status !== 'obsolete' &&
  MARKET_TEMPLATES_COMPETITORS.includes(template);

const isOnEventList = (competitor: CompetitorOddsWithStatus): boolean =>
  EVENT_LIST_COMPETITORS.includes(competitor.slug);

const getMonitoringCompetitors = () =>
  COMPETITORS_ORDER.filter(slug => MONITORING_COMPETITORS.includes(slug));

const isOnMonitoringPage = (competitorSlug: CompetitorSlug) =>
  MONITORING_COMPETITORS.includes(competitorSlug);

const categoryHasCompetitor = (category: string): boolean =>
  MARKET_CATEGORY_COMPETITORS.includes(category);

export {
  displayCompetitorOutcome,
  isOnEventList,
  categoryHasCompetitor,
  getMonitoringCompetitors,
  isOnMonitoringPage
};
